<template>
  <table
    :style="cssVars"
    :class="style.borders ? 'bordered' : ''"
    class="styled-table">
    <tr class="border-top">
      <td
        class="categ-title extra-pad"
      >
        Diagnósticos
      </td>
      <td colspan="4" class="categ-title" style="text-align: center !important;" >
        Totais
      </td>
    </tr>

    <template v-for="(parent, index) in tableValues" >
      <tr :key="index" class="border-top" style="text-align: center !important;">
        <td  class="categ-title" >
          <span v-if="parent">{{parent.label}}</span>
        </td>
        <td class="categ-title" >
          <span v-if="parent">{{parent.total}}</span>
        </td>
        <td class="categ-title" >
          <span v-if="parent">{{getPercent(parent.total, tableTotal)}}%</span>
        </td>
      </tr>
      <template v-if="parent && parent.children">
        <TreeNodes
          :key="parent.id+index"
          :nodes="parent.children"
          :depth="0"
        />
      </template>
    </template>
    <tr>
      <td>Total</td>
      <td>{{tableTotal}}</td>
      <td>100%</td>
    </tr>
  </table>
</template>

<script>
import { TreeDataDictionary } from '../../../../models/Specialty'
import TreeNodes from './TreeNodes.vue'
export default {
  props: {
    logs: { type: Array },
    statsData: { type: Object }
  },
  components: {
    TreeNodes
  },
  data() {
    return {
      inpatientTotal: 0,
      apointmentTotal: 0,
      treeItems: [],
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
    }
  },
  methods: {
    getTreeItems(component) {
      const tree = TreeDataDictionary.query()
        .where('tabName', component.tabName)
        .first()
      return tree.treeData || []
    },
    getTreeItemCount(treeItem, logID) {
      if(treeItem.id === logID) {
        treeItem.count ? treeItem.count + 1 : treeItem.count = 1 
      } else if(treeItem.children && treeItem.children.length > 0) {
        treeItem.children.map(child => {
          this.getTreeItemCount(child, logID)
        })
      }
      return treeItem
    },
    trimTree(items) {
      if(items.children) {
        items.children = items.children.filter(
          item => {
            if(item.count) {return !!item.count}
            if(item.children) {
              return item.children.length !== 0
            }
          }
        )
        items.children = items.children.map(treeItem => treeItem = this.trimTree(treeItem))
        items.children = items.children.filter(item => {
          return item.children ? item.children.length !== 0 : true
        })
      }
      return items
    },
    getTreeParentCount(tree) {
      function calculateTotals(d) {
        let count = d.count ? d.count : 0
        if(d.children) {
            d.children.forEach(c => count += calculateTotals(c))
          }
        return d.total = count
      }
      const result = tree.map(d =>{
        d.total = calculateTotals(d)
        return d
      })
      return result
    },
    getPercent(value, total) {
      return ((value / total) * 100).toFixed(0)
    }
  },
  computed: {
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    },
    labeledLogs() {
      const logs = this.$store.getters.labeledLogs.filter(log => log.logbook === this.statsData.logbookType)
      return logs
    },
    tableValues() {
      const varId = this.statsData.variables.row1.id
      let treeItems = JSON.parse(JSON.stringify(this.treeItems))
      this.labeledLogs.forEach(log => {
        if(log[varId]) {
          log[varId].id.map(logID => {
            treeItems.map(treeItem => {
              treeItem = this.getTreeItemCount(treeItem, logID)
            })
          })
        } 
      })

      treeItems = this.getTreeParentCount(treeItems)
      treeItems = treeItems.filter(item => item.total !== 0)
      treeItems = treeItems.map(item => item = this.trimTree(item))
      return treeItems
    },
    tableTotal() {
      return this.tableValues.reduce((a, b) => +a + +b.total, 0)
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
    this.treeItems = this.getTreeItems(this.statsData.variables.row1)
  },
  watch: {
    statsData: {
      handler(val, oldVal) {
        if(val !== oldVal) {
          this.treeItems = this.getTreeItems(this.statsData.variables.row1)
        }
      },
      deep: true
    }
  }
}
</script>

<style>

</style>